import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { pendingFlag, PendingFlag } from '@platform/shared/utilities/pending-flag';

interface CommentCreateForm {
  comment: FormControl<string | null>;
}

@Component({
  selector: 'app-comment-create-form',
  templateUrl: './comment-create-form.component.html',
  styleUrls: ['./comment-create-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentCreateFormComponent {
  @Input({ required: true }) createComment: (comment: string, pendingFlag: PendingFlag, successCallback: () => void) => void;

  public submitPendingFlag = pendingFlag();
  public form: FormGroup<CommentCreateForm> = new FormGroup({
    comment: new FormControl<string | null>('', [Validators.required]),
  });

  submit() {
    if (this.form.valid) {
      this.createComment(this.form.value.comment ?? '', this.submitPendingFlag, () => this.form.reset());
    }
  }
}
